var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24.9768 8L8.97681 24","stroke":"#F4F4F4","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8.97681 8L24.9768 24","stroke":"#F4F4F4","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Close.defaultProps = {"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none"};

module.exports = Close;

Close.default = Close;
